// @flow

import { type OutgoingPayment } from '../outgoing-payment/types';

export function oxxopayOutgoingPaymentMapper(): $Shape<OutgoingPayment> {
  return {
    payment_type: 'oxxopay',
    payment_type_code: 'oxxopay',
  };
}
